import { z } from "zod";
/** Phase 5: public API clients, outbound webhooks, audit log. */
// ---------- API clients (OAuth2 client credentials in Keycloak) ----------
export const createApiClientSchema = z.object({
    name: z.string().trim().min(2).max(80),
    rateLimitPerMin: z.number().int().min(10).max(5000).optional(),
});
export const updateApiClientSchema = z.object({
    name: z.string().trim().min(2).max(80).optional(),
    active: z.boolean().optional(),
    rateLimitPerMin: z.number().int().min(10).max(5000).optional(),
});
// ---------- Webhooks ----------
/** Domain events a subscriber may choose; "*" means everything. */
export const WEBHOOK_EVENTS = [
    "checklist.created",
    "bag_checklist.created",
    "unit.loggedIn",
    "unit.shiftEnded",
    "hospital.created",
    "hospital.updated",
    "hospital.deleted",
    "ambulance.created",
    "ambulance.updated",
    "ambulance.deleted",
    "unit_code.created",
    "unit_code.updated",
    "unit_code.deleted",
    "user.created",
    "user.updated",
    "user.deleted",
];
export const createWebhookSchema = z.object({
    url: z.string().trim().url().max(2000),
    events: z.array(z.union([z.enum(WEBHOOK_EVENTS), z.literal("*")])).min(1).max(50),
});
export const updateWebhookSchema = z.object({
    url: z.string().trim().url().max(2000).optional(),
    events: z.array(z.union([z.enum(WEBHOOK_EVENTS), z.literal("*")])).min(1).max(50).optional(),
    active: z.boolean().optional(),
});
//# sourceMappingURL=integrations.js.map